import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const defaultOtherBrandOption = '__OTHERS__';

const useBrandOptions = (otherValue = defaultOtherBrandOption) => {
    const { t } = useTranslation(['common']);

    return useMemo(() => {
        const options = [
            t('common:brands.porsche'),
            t('common:brands.mcLaren'),
            t('common:brands.rollsRoyce'),
            t('common:brands.mini'),
            t('common:brands.mazda'),
            t('common:brands.mg'),
            t('common:brands.eurokarsPreowned'),
            t('common:brands.bmw'),
            t('common:brands.enpl'),
            t('common:brands.hongqi'),
        ].map(label => ({ value: label, label }));

        options.push({ value: otherValue, label: t('common:brands.others') });

        return options;
    }, [t, otherValue]);
};

export default useBrandOptions;
